import type { HelpFile } from '../../types/help'
import { MyApprovalsTestIds, MyApprovalsTabId } from '../../../testids/MyApprovalsTestIds'

export const myApprovalsHelp: HelpFile = {
  docPage: '/docs/governance/my-approvals',
  texts: {
    [MyApprovalsTestIds.myApprovalsPage]: 'Inbox of pending approvals — access requests, function-group requests, Auto-Assign Rule changes, and Restriction Rule exceptions.',
    [MyApprovalsTestIds.approvalCard]: null,
    [MyApprovalsTestIds.fgApprovalCard]: null,
    [MyApprovalsTestIds.ruleApprovalCard]: null,
    [MyApprovalsTestIds.sodApprovalCard]: null,
    [MyApprovalsTestIds.approvalsAccessRequestsPanel]: null,
    [MyApprovalsTestIds.approvalsFgRequestsPanel]: null,
    [MyApprovalsTestIds.approvalsRuleRequestsPanel]: null,
    [MyApprovalsTestIds.approvalsSodRequestsPanel]: null,
    [MyApprovalsTestIds.btnBatchApprove]: 'Approve all selected items at once.',
    [MyApprovalsTestIds.btnBatchReject]: 'Reject all selected items at once — requesters are notified.',
    [MyApprovalsTestIds.sodRequestsEmptyState]: null,
    [MyApprovalsTestIds.tab(MyApprovalsTabId.AccessRequests)]: 'Access requests pending a decision — approve to grant the requested Access Profiles, or reject with a reason.',
    [MyApprovalsTestIds.tab(MyApprovalsTabId.RuleRequests)]: 'Auto-Assign Rule change requests pending approval.',
    [MyApprovalsTestIds.tab(MyApprovalsTabId.FgRequests)]: 'Function-group change requests pending a decision.',
    [MyApprovalsTestIds.tab(MyApprovalsTabId.SodRequests)]: 'Restriction Rule exception requests pending approval.',
    [MyApprovalsTestIds.btnApprovePrefix()]: 'Approve — the requested Access Profiles are granted and the requester is notified.',
    [MyApprovalsTestIds.btnRejectPrefix()]: 'Reject — the access is not granted; a reason is required before confirming.',
    [MyApprovalsTestIds.btnApproveFgPrefix()]: 'Approve — the requested function-group bundle is granted to the beneficiary.',
    [MyApprovalsTestIds.btnRejectFgPrefix()]: 'Reject — the function-group bundle is not granted; a reason is required.',
    [MyApprovalsTestIds.btnApproveRulePrefix()]: 'Approve — the Auto-Assign Rule change takes effect immediately.',
    [MyApprovalsTestIds.btnRejectRulePrefix()]: 'Reject — the Auto-Assign Rule remains unchanged.',
    [MyApprovalsTestIds.btnApproveSodPrefix()]: 'Approve — the beneficiary may hold the otherwise-conflicting access for the granted period.',
    [MyApprovalsTestIds.btnRejectSodPrefix()]: 'Reject — the conflicting access is not permitted; a reason is required.',
  },
}
